<template>
    <div class="d-md-flex align-items-center justify-content-between mb-2 mt-2">
        <div>
            <h4 class="main-title mb-0">Property Types</h4>
        </div>
    </div>
    <div class="row g-3 mb-2">
        <div class="col-xl-4">
            <form class="card card-one" @submit.prevent="submitForm()">
                <div class="card-header">
                    <h6 class="card-title" v-if="status">New Property Type </h6>
                    <h6 class="card-title" v-else>Update Property Type </h6>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12">
                            <label class="form-label">Property Type</label><span class="text-danger"> *</span>
                            <input type="text" class="form-control" placeholder="Property Type" :class="{'is-invalid': errors.property_type}" v-model="property_type.property_type" ref="property_type" />
                            <span v-if="errors.property_type" class="invalid-feedback">{{ errors.property_type[0] }}</span>
                        </div>
                        <!-- <div class="col-md-12 mt-3">
                            <label class="form-label">Unit</label><span class="text-danger"> *</span>
                            <input type="text" class="form-control" placeholder="Enter measuring measuring_unit" :class="{'is-invalid': errors.measuring_unit}" v-model="property_type.measuring_unit" ref="measuring_unit" />
                            <span v-if="errors.measuring_unit" class="invalid-feedback">{{ errors.measuring_unit[0] }}</span>
                        </div> -->
                    </div>                   
                </div>
                <div class="card-footer text-end">
                    <button class="btn btn-danger me-2" type="button" @click="discard()"> <i class="ri-prohibited-line me-1"></i>Discard</button>
                    <button class="btn btn-primary " type="submit">
                        <span v-if="status"> <i class="ri-save-line me-1"></i> Submit</span>
                        <span v-else> <i class="ri-save-line me-1"></i> Update </span>
                    </button>
                </div>
            </form>
        </div>
        <div class="col-xl-8">
            <div class="card card-one">
                <div class="card-header">
                    <h6 class="card-title">Property Type</h6>
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <input type="text" class="form-control mb-2" id="search" placeholder="Search" v-model="meta.search" @keypress.enter="search()">
                    </div>
                    <div class="table-responsive">
                        <table class="table table-striped text-nowrap table-bordered table-hover table-bottom-border mb-0">
                            <thead>
                                <tr style="background-color: #f5f5f5;">
                                    <th class="text-center">Sl No.</th>
                                    <th @click="sort('property_type')">
                                        Property Type
                                        <span>
                                            <i v-if="meta.keyword=='property_type' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                            <i v-else-if="meta.keyword=='property_type' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                            <i v-else class="fas fa-sort"></i>
                                        </span>
                                    </th>
                                    <!-- <th>Measuring Unit</th> -->
                                    <th class="text-center">Status</th>
                                    <th class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="property_type, key in property_types" :key="key">
                                    <td class="text-center">{{ meta.from + key }}</td>
                                    <td>{{property_type.property_type}}</td>
                                    <!-- <td>{{ property_type.measuring_unit }}</td> -->
                                    <td class="text-center">
                                        <div class="form-switch">
                                            <input class="form-check-input" type="checkbox" role="switch" :id="'property_type' + property_type.property_type_id" :checked="property_type.status" :value="property_type.status" @change="deletePropertyType(property_type)" />
                                            <label class="custom-control-label" :for="'property_type' + property_type.property_type_id"></label>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <nav v-if="property_type.status">
                                            <a href="javascript:void(0)" class="text-primary me-2" @click="edit(property_type)"><i class="ri-edit-line fs-18 lh-1"></i></a>
                                        </nav>
                                    </td>
                                </tr>
                                <tr v-if="property_types.length <= 0">
                                    <td colspan="3" style="text-align: center;">No Records Found</td>
                                </tr>
                           
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card-footer">
                    <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                </div>
            </div>
        </div>
       
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    export default {
        components: {
            Pagination,
        },
        data() {
            return {
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "property_type_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    maxPage: 1,
                },
                property_type:{
                    property_type_id:"",
                    property_type:"",
                    measuring_unit: ""
                },
                property_types:[],
                status:true,
                errors: [],
            };
        },
        mounted() {
            let vm = this;
            vm.$refs.property_type.focus();
            vm.index();
        },

        methods: {
            submitForm() {
                let vm = this;
                if (vm.status) {
                    vm.create();
                } else {
                    vm.update();
                }
            },
            index() {
                let vm = this;
                vm.$store.dispatch("post", { uri: "paginatePropertyTypes", data: vm.meta })
                .then(function (response) {
                    vm.property_types = response.data.data;
                    vm.meta.totalRows = response.data.meta.total;
                    vm.meta.lastPage = response.data.meta.last_page;
                    vm.meta.from = response.data.meta.from;
                    vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                })
                .catch(function (error) {
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },
            create(){
                let vm = this;
                let loader = vm.$loading.show();
                let uri = { uri: "addPropertyType", data: vm.property_type };
                vm.$store.dispatch("post", uri)
                .then(function () {
                    loader.hide();
                    vm.$store.dispatch("success", "Property Type is successfully created");
                    vm.discard();
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },
            edit(property_type){
                let vm = this;
                vm.property_type = property_type;
                vm.status = false;
                vm.$refs.property_type.focus();
            },
            update(){
                let vm = this;
                let loader = vm.$loading.show();
                let uri = { uri: "updatePropertyType", data: vm.property_type };
                vm.$store
                    .dispatch("post", uri)
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "Property Type is successfully updated");
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            deletePropertyType(property_type){
                let vm = this;
                let loader = vm.$loading.show();
                let uri = { uri: "deletePropertyType", data: property_type };
                vm.$store
                    .dispatch("post", uri)
                    .then(function (response) {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            discard() {
                let vm = this;
                vm.property_type.property_type = "";
                vm.property_type.property_type_id = "";
                vm.property_type.measuring_unit = "";
                vm.errors = [];
                vm.status = true;
                vm.$refs.property_type.focus();
                vm.index();
            },
            onPageChange(page) {
                this.meta.page = page;
                this.index();
            },
            search(){
               let vm = this;
               vm.meta.page = 1;
               vm.index();
            },
            sort(field) {
                this.meta.keyword = field;
                this.meta.order_by = this.meta.order_by == "asc" ? "desc" : "asc";
                this.index();
            },
        },
    };
</script>
<style scoped>
 input:focus,
    select:focus {
        outline: none;
        box-shadow: 0 0 0 0 transparent;
    }
</style>